import { useMutation } from "@tanstack/react-query";
import { Errors, trackError } from "modules/monitoring";
import { TicketingErrors } from "../../constants";
import request from "./request";

export const usePlaceTicketOrder = (
  orderReference?: string | null,
  eventId?: string | null,
) => {
  const { mutate, status } = useMutation({
    mutationFn: async () => {
      if (!orderReference) {
        throw new Error(TicketingErrors.NO_ORDER_REFERENCE);
      }
      if (!eventId) {
        throw new Error(TicketingErrors.NO_EVENT_ID);
      }

      return request(orderReference, eventId);
    },

    onError: (error: Error, _) => {
      trackError(error, {
        label: Errors.TICKET_ORDER_REGISTRATION_FAILED,
      });
    },
  });

  return { placeTicketOrder: mutate, status };
};
